import auth from './modules/auth/state'
import router from '@/router'
import { logout } from "../api/auth";
import { getCurrencies } from "@/api/currencies";
import { getProjectTypes } from '../api/projects';
import { getAllBrandDetectionModels } from '../api/models';
import * as types from './mutation-types';

export default {
  logout({ commit }) {
    logout()
      .then(() => {
        commit('logout', auth)
        router.push({name: 'login'})
      })
  },
  clearStore ({ commit }) {
    const payload = {
      auth
    }
    commit('logout', payload)
  },
  async fetchCurrencyList({ commit, getters }) {
    if (getters.currency.loading) {
      return;
    }

    try {
      commit(types.SET_CURRENCY_LOADING, true);
      const { data } = await getCurrencies();
      commit(types.SET_CURRENCY_LIST, data.currencies);
    } catch (e) {
      console.log(e);
    } finally {
      commit(types.SET_CURRENCY_LOADING, false);
    }
  },
  fetchProjectTypes({ commit }) {
    getProjectTypes()
      .then((res) => {
        commit('setProjectTypes', res.data.project_types)
      })
  },
  fetchAllBrandDetectionModels({ commit }) {
    getAllBrandDetectionModels()
      .then((res) => {
        commit('setBrandDetectionModels', res.data.models)
      })
  }
}
